import { createFileRoute, redirect } from '@tanstack/react-router';
import { ensurePermissions } from '@/hooks/usePermissions';

export const Route = createFileRoute('/(client)/my-components')({
  beforeLoad: async ({ location }) => {
    const perms = await ensurePermissions();
    if (!perms.styles.canRead) {
      throw redirect({ to: '/dashboard' });
    }

    // Lives here, not in `(pages)`: this layout owns the `/my-components`
    // segment, so a pathless child never matches the bare path.
    if (
      location.pathname === '/my-components' ||
      location.pathname === '/my-components/'
    ) {
      throw redirect({ to: '/my-components/components/active' });
    }
  },
});
